import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetAuthorArticlesSucceed, EGetAuthorArticlesActionType } from './types';
import { IAuthorArticles } from '../../../types/authorArticles';

export const getAuthorArticlesSucceed: (data: IAuthorArticles) => TGetAuthorArticlesSucceed = actionGenerator<
  EGetAuthorArticlesActionType.Succeed,
  IAuthorArticles
>(EGetAuthorArticlesActionType.Succeed);
